import {fonts, colors} from '../../../../theme';

const styles = (theme) => ({
  experienceBackgroundLight: {
    backgroundColor: colors.white,
    paddingBottom: 50,
    paddingTop: 50,
  },
  descriptionLight: {
    fontSize: 16,
    display: 'block',
    margin: 'auto',
    fontFamily: fonts.base,
    color: '#002b2b',
  },
  gridWrapperLight: {
    width: '85%',
    margin: '0px auto 0',
    marginTop: 40,
    paddingBottom: 40,
    position: 'relative',
    borderRadius: 8,
    backgroundColor: colors.lightThemeBlueBackground,
  },
  headerLight: {
    textAlign: 'center',
    fontFamily: fonts.base,
    fontWeight: 600,
    fontSize: 48,
    color: colors.primary,
    marginBottom: 30,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 0,
    },
  },
  imagePanelLight: {
    marginTop: 50,
    margin: 'auto',
    display: 'block',
    boxShadow: '0 0 35px rgba(48,95,129,.1)',
    backgroundColor: colors.white,
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: 225,
    },
    [theme.breakpoints.down('x')]: {
      marginTop: 30,
    },
    width: 300,
  },
  titleLight: {
    fontFamily: fonts.base,
    fontWeight: 600,
    fontSize: 24,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
    color: colors.primary,
    display: 'block',
    margin: 'auto',
  },
  unorderedListLight: {
    color: colors.lightThemeBlack,
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
    marginLeft: 0,
    paddingLeft: 22,
    fontFamily: fonts.base,
  },
});

export default styles;
